import Vue from 'vue'
import VueRouter from 'vue-router'
// const originalPush = VueRouter.prototype.push
// const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
// var path = '/Home/recording'
// if(flag){
//   path= '/Home/recordingh5'
// }
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)
//console.log(flag);
const routes = [
  {
    path: "",
    redirect: "/Index"
  },

  {
    path: "/Index",
    name: "Index",
    component: () => import("../views/Index.vue"),
    meta: {
      title: "首页"
    }
  },

]


const router = new VueRouter({
  routes
})

export default router
